var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLizenzKaufen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Lizenz-Kaufen__Icn/40px/Lizenz-Kaufen",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5,32 C16.3284271,32 17,31.3284271 17,30.5 C17,29.6715729 16.3284271,29 15.5,29 C14.6715729,29 14,29.6715729 14,30.5 C14,31.3284271 14.6715729,32 15.5,32 Z M26.5,32 C27.3284271,32 28,31.3284271 28,30.5 C28,29.6715729 27.3284271,29 26.5,29 C25.6715729,29 25,29.6715729 25,30.5 C25,31.3284271 25.6715729,32 26.5,32 Z M9.04557849,8 C9.92166329,8 10.6887379,8.56885277 10.9509292,9.39184017 L10.9940768,9.54905162 L11.3291133,11 L31.3285768,11 C32.4331463,11 33.3285768,11.8954305 33.3285768,13 C33.3285768,13.1297661 33.3159477,13.2590688 33.2909559,13.3860937 L33.2442293,13.5746958 L30.8442293,21.5746958 C30.6063009,22.3677907 29.9070737,22.9265414 29.0928518,22.9932872 L28.9285768,23 L14.1061133,23 L14.7949977,25.9724121 L27.6726074,25.9724121 C28.2248922,25.9724121 28.6726074,26.4201274 28.6726074,26.9724121 C28.6726074,27.4852479 28.2865672,27.9079193 27.7892285,27.9656844 L27.6726074,27.9724121 L14.7949977,27.9724121 C13.9189129,27.9724121 13.1518383,27.4035593 12.889647,26.5805719 L12.8464994,26.4233605 L9.04557849,10 L6.01611328,10 C5.46382853,10 5.01611328,9.55228475 5.01611328,9 C5.01611328,8.48716416 5.40215347,8.06449284 5.89949216,8.00672773 L6.01611328,8 L9.04557849,8 Z M13.6431133,21 L28.9285768,21 L31.3285768,13 L11.7921133,13 L13.6431133,21 Z",
    id: ".._.._src_svg_Icn_40px_Lizenz-Kaufen__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLizenzKaufen);
export default __webpack_public_path__ + "static/media/Lizenz-Kaufen.32232510464846b53b9089f403490202.svg";
export { ForwardRef as ReactComponent };